export const userEntityRequiredColumns = ['name', 'peopleHandle', 'userType']
export const roleEntityRequiredColumns = ['name', 'roleHandle']
export const processEntityRequiredColumns1 = ['name', 'processHandle']
export const processEntityRequiredColumns2 = ['name', 'catId']

export const getCsvHeaderColumns = csvString => {
  const str = csvString.substr(0, csvString.indexOf('\n'))
  return str.split(/[;\t,]/)
}
